module.exports = __webpack_public_path__ + "img/2_Criteria_Sustainable_Urban_Communities_Cities_Vietnam_frontcover.823fd480.jpg";